/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pctsol_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What does percent (w/v) mean?`)
};

const es_pctsol_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué significa el porcentaje (p/v)?`)
};

const de_pctsol_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was bedeutet Prozent (w/v)?`)
};

const nl_pctsol_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat betekent percentage (g/v)?`)
};

const fr_pctsol_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que signifie le pourcentage (p/v) ?`)
};

const it_pctsol_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cosa significa percentuale (p/v)?`)
};

const pt_br2_pctsol_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que significa percentual (p/v)?`)
};

const pt_pctsol_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que significa percentagem (m/v)?`)
};

const ja_pctsol_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パーセント (w/v) とは何ですか？`)
};

const zh_pctsol_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`百分比（w/v）是什么意思？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pctsol_faq_q1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pctsol_faq_q1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pctsol_faq_q1", locale)
	if (locale === "en") return en_pctsol_faq_q1(inputs)
	if (locale === "es") return es_pctsol_faq_q1(inputs)
	if (locale === "de") return de_pctsol_faq_q1(inputs)
	if (locale === "nl") return nl_pctsol_faq_q1(inputs)
	if (locale === "fr") return fr_pctsol_faq_q1(inputs)
	if (locale === "it") return it_pctsol_faq_q1(inputs)
	if (locale === "pt-BR") return pt_br2_pctsol_faq_q1(inputs)
	if (locale === "pt") return pt_pctsol_faq_q1(inputs)
	if (locale === "ja") return ja_pctsol_faq_q1(inputs)
	return zh_pctsol_faq_q1(inputs)
};